const ConvertUTCDateToLocalDate = ({ date, label }) => {
  const newDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60 * 1000,
  ).toLocaleString();

  return label + newDate;
};

export default ConvertUTCDateToLocalDate;
